const Loading = () => (
	<div>
		<img
			src="https://samherbert.net/svg-loaders/svg-loaders/three-dots.svg"
			alt="three dots"
		/>
	</div>
);

export default Loading;
